import { render, staticRenderFns } from "./OrderDetailInfo.vue?vue&type=template&id=ac58bc58"
import script from "./OrderDetailInfo.vue?vue&type=script&lang=js"
export * from "./OrderDetailInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports